import { Table } from '@flos/react-ui';
import { type RowInformation } from '../../config/flavourConfig';

const ItemListRow = ({ rowInfo }: { rowInfo: RowInformation }): React.JSX.Element => {
    return (
        <Table.Row>
            <Table.Cell align="left">
                <ul className="u-spacing-stack-none">
                    <li>{typeof rowInfo.fieldValue === 'string' ? rowInfo.fieldValue : ''}</li>
                </ul>
            </Table.Cell>
        </Table.Row>
    );
};

export default ItemListRow;
